import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  dialogContent: {
    gap: spacing(30),
    padding: spacing(40),
    minHeight: spacing(50),
    overflowY: 'auto',
    justifyContent: 'flex-start',
    overflowX: 'hidden',
  },
}))
